import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a7acee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-wr" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" })
], -1))
const _hoisted_3 = { class: "avatar-wr" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info-block" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link" }, "View Profile", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", null, [
      _createElementVNode("ul", {
        class: _normalizeClass({ 'role-coach': !$setup.isUser })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getNavigationList, (item, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.title
          }, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", [item.class, { 'router-link-active': $setup.router.currentRoute.value.path.startsWith(item.route) }, { hasUnreadMessage: idx === $setup.getNavigationList.length - 1 && $setup.isSignedAtTermsOfUse && !$setup.isCoach && $setup.chatStore.countUnreadMessage }]]),
              to: item.route
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ]))
        }), 128))
      ], 2)
    ]),
    _createVNode(_component_router_link, {
      class: "profile-wr",
      to: { name: $setup.isUser ? 'Billing' : 'EditProfile' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "avatar",
            src: require('@/assets/img/default-avatar.svg'),
            alt: "Avatar"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString($setup.isUser ? $setup.userStore.data.fullName : $setup.coachStore.data.fullName), 1),
          _hoisted_7
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}